module.exports = __webpack_public_path__ + "static/media/cabbagetreelandscape.7feddacb.png";